import { render, staticRenderFns } from "./AiFloatEntry.vue?vue&type=template&id=895a51a2&scoped=true&"
import script from "./AiFloatEntry.vue?vue&type=script&lang=js&"
export * from "./AiFloatEntry.vue?vue&type=script&lang=js&"
import style0 from "./AiFloatEntry.vue?vue&type=style&index=0&id=895a51a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895a51a2",
  null
  
)

export default component.exports